var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    [
      _c(
        "v-row",
        [
          _c(
            "v-col",
            {
              attrs: {
                cols: "12"
              }
            },
            [
              _c(
                "v-row",
                [
                  _c(
                    "v-col",
                    {
                      attrs: {
                        cols: "12",
                        md: "6"
                      }
                    },
                    [
                      _c(
                        "gg-card-title",
                        {
                          staticClass: "pb-0"
                        },
                        [_vm._v(" Support ")]
                      )
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    {
                      staticClass: "text-right mt-2",
                      attrs: {
                        cols: "12",
                        md: "6"
                      }
                    },
                    [
                      _c(
                        "div",
                        [
                          _c(
                            "gg-btn",
                            {
                              staticClass: "mt-1 mr-1",
                              attrs: {
                                right: "",
                                to: {
                                  name: "support_ticketnew"
                                }
                              }
                            },
                            [_vm._v(" Open new ticket ")]
                          )
                        ],
                        1
                      )
                    ]
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "v-col",
            {
              attrs: {
                cols: "12"
              }
            },
            [_c("support-token")],
            1
          ),
          _c(
            "v-col",
            {
              attrs: {
                cols: "12"
              }
            },
            [
              _c("ticket-list", {
                attrs: {
                  pagination: _vm.pagination,
                  location: "list"
                }
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }